/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/Inputs/Content/Message/Content/Details/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let messageValueData = fromData.useDataValue({ viewPath,
context: 'message',
})
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="large"
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaModalHeaderTitle
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Error detail"
/>
</div>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 disabled={true}
 data="message"
 height={300}
 fontFamily="monospace"
 value={messageValueData}
>
{childProps => (
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
)}
</TysiaTextarea>
</div>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<TysiaModalFooterAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../No'))}
 text="Close"
/>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}